// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'pencil';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.699 1.301a2.75 2.75 0 0 0-3.906.027L1.837 12.283.5 17.5l5.217-1.338L16.672 5.207A2.748 2.748 0 0 0 16.7 1.3zm-4.219.34 3.879 3.88M1.838 12.282l3.883 3.876'
  />
);

export const viewBox = '0 0 18 18';
